//Button that brings up iframe-ish thingy

import React, { useState, useEffect, useRef } from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem, Content, Separator, View, Card, CardItem, H3 } from 'native-base';
import { Platform, Linking, StyleSheet, Dimensions, ScrollView } from 'react-native';
import { useSelector, shallowEqual } from 'react-redux';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import Modal from './modal';
import { WebView } from 'react-native-webview';
import CalCalDataApi from '../api/CalCalDataApi';

export default function TawkToButton() {
	const [visible, setVisible] = useState(false);
	const [showTitle, setShowTitle] = useState(true);
	const [objUrl, setObjUrl] = useState();
	const [hash, setHash] = useState('');

	const { user, jwt, userInfo } = useSelector(
		state => ({
			user: state.loginReducer.user,
			jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
			userInfo: state.loginReducer.userInfo
		}),
		shallowEqual
	);

	//const webViewRef = useRef(null);

	//const frameUrl = userInfo && hash && `https://tawk.to/chat/59ce5807c28eca75e4623212/1brecb7hr?$_tawk_popout=true&hash=${hash}&name=${userInfo.user.user_nicename}&email=${userInfo.user.user_email}`;
	const frameUrl = `https://tawk.to/chat/59ce5807c28eca75e4623212/1brecb7hr?$_tawk_popout=true`;
	const url = 'https://calc.al/api/chat';
	/*
	const js = `
setTimeout(function() {
    window.ReactNativeWebView.postMessage('YO!!! ' + JSON.stringify(Tawk_API));
var Tawk_API=Tawk_API||{};
Tawk_API.visitor = {
name : 'Fred',
email : 'fred@nikrooz.co.uk'
};
//document.getElementById('greetingsMainContainer').style.backgroundColor='blue';
Tawk_API.onChatEnded = function(){
   window.ReactNativeWebView.postMessage('ended');
};

var Tawk_LoadStart=new Date();
}, 2500);
`;*/

	/*<>
							<div id="tawk_59ce5807c28eca75e4623212"></div>

							<script type="text/javascript">var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); Tawk_API.embedded='tawk_59ce5807c28eca75e4623212';</script>
							<script src="https://embed.tawk.to/59ce5807c28eca75e4623212/1brecb7hr" crossorigin="*" async />
						</>*/

	const onNavigationStateChange = f => {
		//console.log(f);
		if (f.url != url) doClose();

		//hide header when loaded
		/*if (!f.loading) {
			setShowTitle(false);
		}*/
		//doClose();
	};

	const doClose = () => {
		setVisible(false);
	};

	const doOpen = () => {
		setVisible(true);
		setShowTitle(true);
	};

	const { width, scale } = Dimensions.get('window');
	const zoom = width ? (width / (380 * scale)).toString() : '1';

	const onMessage = event => {
		console.log(event);
		const msg = event.nativeEvent.data;

		if (msg == 'loaded') setShowTitle(false);
		if (msg == 'ended') doClose();
	};

	//__DEV__ && console.log(Dimensions.get('window'), zoom);
	//htmlContent = htmlContent && htmlContent.replace('<html>', '<html style="zoom:' + zoom + '">');
	/*useEffect(() => {
		if (visible && Platform.OS == 'web' && !objUrl) {
			CalCalDataApi.dataLoad('chat', jwt, res => {
				if (__DEV__) console.log(res);

				if (res.success) setHash(res.hash);
			});
			/*fetch(url, {
				method: 'GET',
				headers: new Headers({
					'X-Token': 'Bearer ' + jwt.token
				})
			})

				.then(response => response.blob())
				.then(blob => {
					setObjUrl(window.URL.createObjectURL(blob));
				});*
		}
	}, [visible]);*/

	return (
		<>
			<Button transparent rounded androidRippleColor="white" onPress={() => doOpen()}>
				<Icon active name="ios-help-circle-outline" />
			</Button>
			<Modal
				isOpen={visible}
				backdropPressToClose
				coverScreen
				backdropColor="#295670"
				backButtonClose
				style={{ width: '90%', height: '90%', borderRadius: 10, backdropColor: '#FFF' }}
				swipeThreshold={100}
				backdropOpacity={0.5}
				onClosed={() => doClose()}
				//backdropOpacity={0.7}
				useNativeDriver>
				{showTitle && (
					<Header style={{ height: 45, borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
						<Body>
							<Title>Live Chat</Title>
						</Body>
						<Right>
							<Button transparent onPress={() => doClose()}>
								<Icon name="arrow-dropdown" />
							</Button>
						</Right>
					</Header>
				)}
				<View style={{ flex: 1, backgroundColor: '#FFF' }}>
					{Platform.OS == 'web' ? (
						visible ? (
							<iframe style={{ border: 1, borderColor: '#444', borderStyle: 'dotted', margin: 10, flex: 1 }} src={frameUrl} />
						) : (
							<div />
						)
					) : (
						<WebView
							style={{ backgroundColor: '#FFF', flex: 1, width: '100%' }}
							scalesPageToFit={false}
							automaticallyAdjustContentInsets={true}
							startInLoadingState={true}
							scrollEnabled={false}
							onNavigationStateChange={onNavigationStateChange}
							source={{ uri: url, headers: { Accept: 'text/html', 'X-Token': 'Bearer ' + jwt } }}
							injectedJavaScriptForMainFrameOnly={false}
							onMessage={onMessage}
						/>
					)}
				</View>
			</Modal>
		</>
	);
}
